import './Single.scss';

ComponentManager.init(document.body);
